export const StorageSecret = 'secret';

export enum StorageKeys {
    SELECTED_LANGUAGE = '@selected_language',
    IS_LOGGED_IN = '@is_logged_in'
}